import { styled } from '@mui/material';
import { BaseCard, BaseCardLabel } from 'console/shared/styles/mixins/base-card';
export const CustomControlsCard = styled(BaseCard)({
    display: 'flex',
    flexDirection: 'column',
});
export const CustomControlsCardTitle = styled(BaseCardLabel)({});
export const CustomControlsCardCurrentLabel = styled(BaseCardLabel)({});
